import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import api from '../../../../../../api';
import breakpoints from '../../../../../../breakpoints';
import { compose, setPropTypes } from '../../../../../hoc/recompose';
import { withData } from '../../../../../hoc/withData';
import withMatchMedia from '../../../../../hoc/withMatchMedia';
import { getCurrentUser } from '../../../../../services/CurrentUser';
import NoAssessment from '../../../pages/EditPage/NoAssessment';
import { VIEW_LAYOUTS } from '../../../pages/ViewPage/Header';
import { getNoReviewerOnViewScreenWording } from '../../../services/wording';
import LoadingIndicator from '../../LoadingIndicator';
import styles from './style.m.less';

const errorComponent = ({ error }) => {
    if (!error) {
        return null;
    }

    if (get('response.data.message', error) === 'REVIEWER_NOT_FOUND') {
        const message = getNoReviewerOnViewScreenWording(getCurrentUser());
        return <NoAssessment message={message} showHomeButton={false} />;
    }
};

const PendingComponent = () => (
    <div className={styles.loadingContainer}>
        <LoadingIndicator />
    </div>
);

export default compose(
    setPropTypes({
        reviewId: PropTypes.string.isRequired,
    }),
    withData({
        pendingComponent: PendingComponent,
        errorComponent,
        resolve: {
            component: () => import(/* webpackChunkName: 'ReviewViewPage' */ './presenter'),
        },
        observe: {
            review: ({ reviewId }) => api.reviews.getReview.createObservable(reviewId),
            assessments: ({ reviewId }) => api.reviewAssessments.getAssessmentsForReview.createObservable(reviewId),
        },
    }),
    withMatchMedia(() => ({
        viewLayout: {
            queries: {
                [`(max-width: ${breakpoints.contentBreakPointS})`]: VIEW_LAYOUTS.STACKED,
            },
            default: VIEW_LAYOUTS.SIDE_BY_SIDE,
        },
    }))
)(({ component: { default: Component }, ...props }) => {
    // We must ensure that assessments & review fit together.
    // They can diverge e.g. when switching between previews in clippy.
    if (props.assessments.some(assessment => assessment.reviewId !== props.review.id)) {
        return <PendingComponent />;
    }
    return <Component {...props} />;
});
